__turbopack_context__.v({
  "deliveryMethodWrapper": "_5y1r3a_deliveryMethodWrapper",
  "errorIcon": "_5y1r3a_errorIcon",
  "imageContainer": "_5y1r3a_imageContainer",
  "nameWrapper": "_5y1r3a_nameWrapper",
  "price": "_5y1r3a_price",
  "unchecked": "_5y1r3a_unchecked",
});
